import {
	Box,
	//Box,
	IconButton, Tooltip, Typography
} from "@mui/material"
import styled from "@emotion/styled"
import {useDispatch} from "react-redux"
import {fetchNoteCitationsAndSwitchPanels} from "../../../reducers/noteArticleTabsV2Slice"

const NoteCounter = styled(IconButton,
	//{ shouldForwardProp: (prop) => prop !== "directConnectionCounter" || prop !== "hasAttachments"}
)(() => ({
	alignSelf: "stretch",
	minWidth: "50px",
	minHeight: "34px",
	justifyContent: "end",
	alignItems: "center",
	color: "primary",
	flexGrow: 0,
	// this governs the "always on" background color. The hover color is managed by MUI's button component.
	//backgroundColor: noteInPath ? theme.palette.primary.counter : "inherit",
	// variants: [
	// 	{
	// 		props: ({directConnectionCounter}) => directConnectionCounter,
	// 		style: {
	// 			backgroundColor: noteInPath ? theme.palette.tertiary.counter : "inherit",
	// 			color: "orange",
	// 			["&:hover"]: {
	// 				color: theme.palette.primary.main,
	// 				backgroundColor: noteInPath ? theme.palette.tertiary.counterHover : "",
	// 			}
	// 		}
	// 	}
	// ],
}))

export default function NoteCounters({note}) {
	const dispatch = useDispatch()
	const openArticles = ({singleNote}) => {
		dispatch(fetchNoteCitationsAndSwitchPanels({
			note,
			singleNote
		}))
	}
	const SHOW_TOTAL_COUNTER = note?.childCount > 0 && (note?.uniqueCount + note?.attachmentCount > 0)
	const SHOW_DIRECT_COUNTER = ((note?.articleNoteCount + note?.attachmentNoteCount) > 0 || note?.childCount === 0)
	return (
		<div style={{ minHeight: "34px", display: "flex", }}>
			{
				SHOW_TOTAL_COUNTER && (
					<Tooltip
						title={"Total Connections Link"}
						placement={"left"}
						enterDelay={300}
						enterNextDelay={1000}
						leaveDelay={0}
					>
						<NoteCounter
							//directConnectionCounter={false}
							//noteInPath={noteInPath}
							onClick={() => openArticles({singleNote: false})}
							color={"primary"}
						>
							<Typography
								variant={"body1"}
								sx={{
									padding: "4px 8px"
								}}
							>
								{note?.uniqueCount + note?.attachmentCount}
							</Typography>
						</NoteCounter>
					</Tooltip>
				)
			}
			{
				SHOW_DIRECT_COUNTER ? (
					<Tooltip
						title={"Direct Connections Link"}
						placement={"right"}
						enterDelay={300}
						enterNextDelay={1000}
						leaveDelay={0}
					>
						<NoteCounter
							//directConnectionCounter={true}
							//noteInPath={noteInPath}
							onClick={() => openArticles({singleNote: true})}
							color="primary"
						>
							<Typography
								variant={"body1"}
								sx={{
									padding: "4px 8px",
								}}
							>
								{note?.articleNoteCount + note?.attachmentNoteCount}
							</Typography>
						</NoteCounter>
					</Tooltip>
				) : ( // ...else, render a blank space for formatting
					<Box sx={{width: "50px", flexGrow: 1}} />
				)
			}
		</div>
	)
}
